import { createSlice } from '@reduxjs/toolkit';

import { OverlayPayloadActionType, OverlayPayloadReloadTableCallback } from 'src/models/store/overlay';

export type OverlaySliceStateType = {
  show: boolean;
  id: number | null;
  key: number | null;
  type: 'campaign' | 'teams' | 'members' | 'donorProfile' | 'liveEvent' | null;
  noSearchParam: boolean;
  reloadTableCallback?: () => void;
};

const initialState: OverlaySliceStateType = {
  show: false,
  id: null,
  key: null,
  type: null,
  noSearchParam: false,
};

/**
 * only one type can be active at the moment
 */
export const overlaySlice = createSlice({
  name: 'overlay',
  initialState,
  reducers: {
    // eslint-disable-next-line @typescript-eslint/no-empty-function,@typescript-eslint/no-unused-vars
    reloadData: (state, { payload }: OverlayPayloadActionType) => {
      state.key = Math.random();
    },
    show: (state, { payload }: OverlayPayloadActionType) => {
      state.show = true;
      state.id = payload.id;
      state.key = payload.id;
      state.type = payload.type;
      state.noSearchParam = !!payload.noSearchParam;
      state.reloadTableCallback = payload.reloadTableCallback;
    },
    setReloadTableCallback: (state, { payload }: OverlayPayloadReloadTableCallback) => {
      state.reloadTableCallback = payload.reloadTableCallback;
    },
    close: (state) => {
      state.show = false;
      state.id = null;
      state.key = null;
      state.type = null;
      state.noSearchParam = false;
    },
  },
});
